import {Component, Input, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {
  Aangifte,
  AangifteBerekening,
  AangifteRapport, BokkzAlgDataService,
  Box2Berekening,
  IncomeTaxEntity, OpbouwAB, OpbouwBox2, SpecificatieBox2,
  SpecificatieInkomenBox2
} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {BokkzIbDataService,} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, combineLatest, filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-box2-inkomen-uit-ab',
  templateUrl: './box2-inkomen-uit-aanmerkelijk-belang.component.html',
  styleUrls: ['./box2-inkomen-uit-aanmerkelijk-belang.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class Box2InkomenUitAanmerkelijkBelangSamenvattingComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public clientId!: string;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specInkomenBox2FormGroup = this.fb.group<AangifteRapport>({});
    specInkomenBox2 = {} as AangifteRapport;
    berekeningFormGroup = this.fb.group<AangifteBerekening>({});
    berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.specInkomenBox2FormGroup = this.fb.group<AangifteRapport>(({
            specificatieInkomenBox2: this.fb.group<SpecificatieBox2>(({
                opbouw: this.fb.group<OpbouwAB>(({
                    inkomenUitAanmerkelijkBelang: null as unknown as number,
                    verrekendVerlies: null as unknown as number,
                    saldoAanmerkelijkBelang: null as unknown as number,
                    inkomenNaVerlies: null as unknown as number,
                    aandeelPartner: null as unknown as number,
                    verrekendVerliesPartner: null as unknown as number,
                    inkomenNaVerliesPartner: null as unknown as number
                } as OpbouwAB)),
            } as SpecificatieBox2)),
            specificatieBox2: this.fb.group<SpecificatieInkomenBox2>(({
                opbouw: this.fb.group<OpbouwBox2>(({
                    reguliereVoordelen: null as unknown as number,
                    fictieveReguliereVoordelen: null as unknown as number,
                    maximumBedragSchuldenBijVennootschappen: null as unknown as number,
                    eerderInHeffingBetrokkenSchuldBijVennootschappen: null as unknown as number,
                    totaalSchuldenBijVennootschappen: null as unknown as number,
                    eigenWoningSchuldenBijVennootschappen: null as unknown as number,
                    vervreemdingsVoordelen: null as unknown as number,
                    verkrijgingsPrijs: null as unknown as number,
                    aftrekbareKosten: null as unknown as number,
                } as OpbouwBox2))
            } as SpecificatieInkomenBox2))
        } as AangifteRapport));
        this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
            box2: this.fb.group<Box2Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                conserverendeAanslag: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox2>(({
                    inkomenUitAanmerkelijkBelang: null as unknown as number,
                    verrekendVerlies: null as unknown as number,
                    saldoAanmerkelijkBelang: null as unknown as number,
                } as OpbouwBox2)),
            } as Box2Berekening)),
        } as AangifteBerekening));
        this.berekeningPartnerFormGroup = this.fb.group<AangifteBerekening>(({
            partnerBerekening: this.fb.group<AangifteBerekening>(({
                box2: this.fb.group<Box2Berekening>(({
                    inkomen: null as unknown as number,
                    persoonsgebondenAftrek: null as unknown as number,
                    belastbaarInkomen: null as unknown as number,
                    inkomstenbelasting: null as unknown as number,
                    conserverendeAanslag: null as unknown as number,
                    opbouwInkomen: this.fb.group<OpbouwBox2>(({
                        inkomenUitAanmerkelijkBelang: null as unknown as number,
                        verrekendVerlies: null as unknown as number,
                        saldoAanmerkelijkBelang: null as unknown as number,
                    } as OpbouwBox2)),
                } as Box2Berekening)),
            } as AangifteBerekening)),
        } as AangifteBerekening));
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.dataService.aangifteBerekening,
            this.dataService.partnerAangifteBerekening, this.dataService.partnerAangifteRapport,
            this.dataService.aangifteRapport, this.partner]).subscribe(
            ([incomeTaxEntity, berekening, partnerBerekening,
                 partnerRapport, aangifteRapport, partner]) => {
                this.berekening = berekening;
                this.partnerBerekening = partnerBerekening;
                this.aangifteRapport = aangifteRapport;
                this.partnerRapport = partnerRapport;
                this.partnerBoolean = partner;
                this.specInkomenBox2FormGroup.reset();
                this.berekeningFormGroup.reset();
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.updateForm()
                    this.disableFormGroup(this.specInkomenBox2FormGroup);
                    this.disableFormGroup(this.berekeningFormGroup);
                }
            }
        );
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
      return this.specInkomenBox2FormGroup.dirty
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }


    private updateForm() {
        if (this.partnerBoolean) {
            this.specInkomenBox2 = this.partnerRapport;
            this.specInkomenBox2FormGroup.patchValue(this.partnerRapport);
            this.berekeningFormGroup.patchValue(this.partnerBerekening);

        } else {
            this.specInkomenBox2 = this.aangifteRapport;
            this.specInkomenBox2FormGroup.patchValue(this.aangifteRapport);
            this.berekeningFormGroup.patchValue(this.berekening);
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    hasAbDetails(): boolean {
        const opbouw = this.specInkomenBox2.specificatieBox2?.opbouw;

        if (!opbouw) return false;
        return (
            opbouw.reguliereVoordelen !== undefined ||
            opbouw.aftrekbareKosten !== undefined ||
            opbouw.verkrijgingsPrijs !== undefined ||
            opbouw.vervreemdingsVoordelen !== undefined);
    }

}
